// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import '@/css/reset.css'

import ElementUI from 'element-ui';
import './css/theme/index.css';
Vue.use(ElementUI);

import axios from 'axios'//引入axios
Vue.prototype.$axios = axios;//把axios挂载到vue上

import { VueJsonp }  from 'vue-jsonp'
Vue.use(VueJsonp)

import api from '@/js/base.js'
Vue.prototype.api = api

import Cookies from 'js-cookie'
Vue.prototype.Cookies = Cookies

import './icons'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    console.log(to)
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js